import * as React from "react";
import { StatusMessage, Severity } from "~/state/ui/StatusMessage";
import { MessageBar, MessageBarType } from "office-ui-fabric-react/lib/MessageBar";

interface MessageProps
{
    message: StatusMessage;
    onDismiss: (id: string) => void;
}

export const StatusBarMessage = ({ message, onDismiss }: MessageProps) => 
{

    return (
        // tslint:disable-next-line:react-this-binding-issue
        <MessageBar onDismiss={() => onDismiss(message.id)} 
                    messageBarType={getMessageBarType(message.severity)}>
            {message.message}
        </MessageBar>
    );
};

const getMessageBarType = (severity: Severity): MessageBarType => 
{
    switch (severity)
    {
        case "error":
            return MessageBarType.error;
        case "success":
            return MessageBarType.success;
        case "warning":
            return  MessageBarType.warning;
        case "info":
            return MessageBarType.info;
    }
};


// WEBPACK FOOTER //
// ./src/components/util/StatusBarMessage.tsx